// Mappers: transport LC_* DTOs → domain models for the "Mi equipo" filters panel.
// Kept decoupled from the wire shape so the UI never depends on backend casing
// (companyId/companyName, employeeId/employeeName, etc.).

import type {
  LC_MyTeamSectionOut,
  LC_MyTeamCompanyOut,
  LC_MyTeamEmployeeOut,
  LC_GetMyTeamFiltersOut,
  LC_GetMyTeamEmployeesListOut,
  MyTeamSection,
  MyTeamCompany,
  MyTeamEmployee,
  MyTeamFilters,
} from '../types/myTeamFilters.types';


export function mapMyTeamSection(out: LC_MyTeamSectionOut): MyTeamSection {
  return {
    code: out.code,
    label: out.label,
    isDefault: out.isDefault,
  };
}

export function mapMyTeamCompany(out: LC_MyTeamCompanyOut): MyTeamCompany {
  return {
    id: out.companyId,
    name: out.companyName,
  };
}

export function mapMyTeamEmployee(out: LC_MyTeamEmployeeOut): MyTeamEmployee {
  return {
    id: out.employeeId,
    name: out.employeeName,
    taxIdentificationNumber: out.employeeTaxIdentificationNumber,
    companyId: out.companyId,
  };
}

export function mapMyTeamFilters(out: LC_GetMyTeamFiltersOut): MyTeamFilters {
  return {
    sections: (out.sections ?? []).map(mapMyTeamSection),
    companies: (out.companies ?? []).map(mapMyTeamCompany),
    employees: (out.employees ?? []).map(mapMyTeamEmployee),
  };
}

export function mapMyTeamEmployeesList(out: LC_GetMyTeamEmployeesListOut): MyTeamEmployee[] {
  return (out.employees ?? []).map(mapMyTeamEmployee);
}
